module.exports = __webpack_public_path__ + "static/media/services1.d3d08b5b.avif";